import { messages as businessOpportunityManageMessages } from '../views/businessOpportunity/businessOpportunityLang'
export const messages = {
    en: {
        ...businessOpportunityManageMessages.en,
    },
    zh: {
        ...businessOpportunityManageMessages.zh,
    }
}